import { formatPrice } from "../../utils/helpers";
import {
  IModifierGroup,
  IModifierOption,
  ModifierGroupCustomization,
  ModifierOptionCustomization,
} from "../../types";
import {
  MdOutlineRadioButtonChecked,
  MdOutlineRadioButtonUnchecked,
} from "react-icons/md";

interface ModifierOptionProps {
  modifierGroup: IModifierGroup;
  modifierOption: IModifierOption;
  modifierGroupCustomization: ModifierGroupCustomization;
  setModifierGroupCustomization: React.Dispatch<
    React.SetStateAction<ModifierGroupCustomization>
  >;
}

const ModifierOptionWithQty: React.FC<ModifierOptionProps> = ({
  modifierOption,
  modifierGroupCustomization,
  setModifierGroupCustomization,
}) => {
  // Check if the current option is selected
  const isChecked = modifierGroupCustomization.modifierOptions.some(
    (mOption) => mOption._id === modifierOption._id
  );

  const isOutOfStock = modifierOption.haveStock === false;

  const handleSelectModifierOption = () => {
    if (isOutOfStock) return;

    let updatedModifierOptions: ModifierOptionCustomization[];

    if (isChecked) {
      // If already selected, deselect it (remove all selections)
      updatedModifierOptions = [];
    } else {
      // Select only this option (remove others)
      updatedModifierOptions = [
        {
          _id: modifierOption._id,
          qty: 1,
          displayName: modifierOption.displayName,
          price: modifierOption.price,
        },
      ];
    }

    // Update state
    setModifierGroupCustomization((prev) => ({
      ...prev,
      modifierOptions: updatedModifierOptions,
    }));
  };

  const iconClasses = `w-6 h-6 cursor-pointer ${
    isOutOfStock ? "text-gray-300 cursor-not-allowed" : "text-primary"
  }`;

  return (
    <div
      className={`flex gap-1 p-2 border-b border-gray-200 justify-between ${
        isOutOfStock ? "opacity-50 grayscale cursor-not-allowed" : ""
      }`}
    >
      <div className="flex flex-col">
        <div className={isOutOfStock ? "text-gray-400 line-through" : ""}>
          {modifierOption.displayName} {isOutOfStock && "(Indisponible)"}
        </div>
        <div className="text-gray-600 text-sm">
          {`+${formatPrice(modifierOption.price.value)}`}
        </div>
      </div>
      <div onClick={handleSelectModifierOption}>
        {isChecked ? (
          <MdOutlineRadioButtonChecked className={iconClasses} />
        ) : (
          <MdOutlineRadioButtonUnchecked className={iconClasses} />
        )}
      </div>
    </div>
  );
};

export default ModifierOptionWithQty;
